module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6HUybAmF6E1BOadjyExY2M-54c3c79d8e2694298149823fa8b00441.jpg";